import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { OWNER } from "constants/index"
import { PATH_INFOS } from "utils/navigatorUtils"
import { useAppSelector } from "appRedux/hooks"
import { updateViewedUserProfile } from "appRedux/slices/viewedUserSlice"
import { useLazyGetUserProfileQuery, useLazyGetUserProfileByHandleQuery } from "appRedux/slices/userApiSlice"

export default function useUserProfile() {
  const role = useAppSelector((state) => state.global.role)
  const currentPageInfo = useAppSelector((state) => state.global.currentPageInfo)
  const viewedUser = useAppSelector((state) => state.viewedUser)

  const [triggerGetLoggedInUserProfile, loggedInUserProfileResult] = useLazyGetUserProfileQuery()
  const [triggerGetSearchedUserProfileByHandle, viewedUserProfileResult] = useLazyGetUserProfileByHandleQuery()

  const dispatch = useDispatch()

  useEffect(() => {
    if (!currentPageInfo?.dynamicPathParts?.handle) return
    if (currentPageInfo?.path !== PATH_INFOS.profile.path) return
    fetchUserInfo()
  }, [role, JSON.stringify(currentPageInfo?.dynamicPathParts)])

  useEffect(() => {
    if (loggedInUserProfileResult.data && role === OWNER) {
      dispatch(updateViewedUserProfile(loggedInUserProfileResult.data))
    } else if (viewedUserProfileResult.data) {
      dispatch(updateViewedUserProfile(viewedUserProfileResult.data))
    }
  }, [loggedInUserProfileResult.data, viewedUserProfileResult.data, role, dispatch])

  function fetchUserInfo() {
    if (role === OWNER) {
      triggerGetLoggedInUserProfile()
    } else if (currentPageInfo?.dynamicPathParts?.handle) {
      triggerGetSearchedUserProfileByHandle(currentPageInfo?.dynamicPathParts?.handle)
    }
  }

  return {
    profile: viewedUser.profile,
    isFetching: role === OWNER ? loggedInUserProfileResult.isFetching : viewedUserProfileResult.isFetching,
    isError: role === OWNER ? loggedInUserProfileResult.isError : viewedUserProfileResult.isError
  }
}
